import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PROFIT: AppRouteRecordRaw = {
  path: '/profit',
  name: 'profit',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.profit',
    requiresAuth: true,
    icon: 'icon-file',
    order: 6,
  },
  children: [
    {
      path: 'template',
      name: 'ProfitTemplate',
      component: () => import('@/views/profit/template/index.vue'),
      meta: {
        locale: 'menu.profit.template',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default PROFIT; 